//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import gStartUp from '@/common/components/g-start-up/'
import { mapState } from 'vuex';
import { filter } from '@/common/index';
// import appDownloadDialog from './views/components/app-download-dialog/index.vue'

export default {
  name: 'App',
  // components: { gStartUp },
  provide() {
    return {
      parentRoot: this,
    }
  },
  filters: {
        getTimeMS(time) {
            return filter.getTimeMS(time)
        }
    },
  computed: {
      ...mapState({
          isToLogin:state => state.isToLogin,
          UUID: state => state.UUID,
          pushList: state => state.pushList,
      }),
    viewHeight() { // 可是区域的高度
      return (document.documentElement.clientHeight || document.body.clientHeight) + 'px'
    }
  },
  watch: {
    isToLogin(newVal, oldVal) {
        if (newVal > 0) {
            this.isShowNotic = true
        }
    }
  },
  data() {
    return {
        isShowNotic: false,
      isRouterAlive: true ,// 路由刷新
      // startImg: require('./assets/image/common/start-up.jpg')
    }
  },
  created() {
    // document.title='Online Casino | Online Betting | Gamble Online India | EKGAME'
  },
  methods: {
    reload() { // 刷新页面, 比如页面切换多语言数据重置
       this.isRouterAlive = false
       this.$nextTick(function(){
          this.isRouterAlive = true
       })
    },
    jumpMsg() {
        localStorage.setItem('msgTabIndex', 1);
        this.isShowNotic = false;
        // this.$router.push({path: '/My/StationLetter'})
        this.$router.push({path: '/inbox'})
    }
  },
  mounted() {
     // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
     let vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    // We listen to the resize event
    window.addEventListener('resize', () => {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01
      console.log(vh);
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    })
  },
  beforeDestroy() {
  },
}



// WEBPACK FOOTER //
// ./src/pages/build922/App.vue